module.exports = __webpack_public_path__ + "static/website-4135a06f3f1d42f50e6ed9cd48959f1d.jpg";